import axios from 'axios';

const BASE = '/ventas/presupuestos';

export default {
  index(params = {}) {
    const { page = 1, rowsPerPage = 15, estado = null, q = null, origen = null } = params;
    let url = `${BASE}?page=${page}&page_size=${rowsPerPage}`;
    if (estado) url += `&estado=${encodeURIComponent(estado)}`;
    if (q) url += `&q=${encodeURIComponent(q)}`;
    if (origen) url += `&origen=${encodeURIComponent(origen)}`;
    return axios.get(url);
  },

  show(id) {
    return axios.get(`${BASE}/${id}`);
  },

  create(data) {
    return axios.post(BASE, data);
  },

  update(id, data) {
    return axios.put(`${BASE}/${id}`, data);
  },

  destroy(id) {
    return axios.delete(`${BASE}/${id}`);
  },

  cambiarEstado(id, estado) {
    return axios.post(`${BASE}/${id}/estado/${estado}`);
  },

  pdf(id) {
    return axios.get(`${BASE}/${id}/pdf`, { responseType: 'blob' });
  },
};
